import { render, staticRenderFns } from "./WrapperPage.vue?vue&type=template&id=3bccd24a&"
import script from "./WrapperPage.vue?vue&type=script&lang=js&"
export * from "./WrapperPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports